export class Request_User_Login {
  public user_name: string;
  public password: string;
  public finance_centre_id: number;
  public return_url: string;
}
